
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Wifi, WifiOff, AlertCircle } from 'lucide-react';
import { useOptimizedCardPresenceContext } from '@/contexts/OptimizedCardPresenceContext';

interface ConnectionHealthIndicatorProps {
  showLabel?: boolean;
  size?: 'sm' | 'default';
}

export function ConnectionHealthIndicator({ 
  showLabel = false, 
  size = 'default' 
}: ConnectionHealthIndicatorProps) {
  const { isConnected, connectionHealth } = useOptimizedCardPresenceContext();

  if (isConnected && connectionHealth) {
    return showLabel ? (
      <Badge variant="secondary" className="text-xs bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
        <Wifi className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} />
        Connected
      </Badge>
    ) : (
      <Wifi className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} text-green-600`} />
    );
  }

  if (isConnected && !connectionHealth) {
    return showLabel ? (
      <Badge variant="secondary" className="text-xs bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">
        <AlertCircle className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} />
        Issues
      </Badge>
    ) : (
      <AlertCircle className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} text-yellow-600`} />
    );
  }

  return showLabel ? (
    <Badge variant="destructive" className="text-xs">
      <WifiOff className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} />
      Disconnected
    </Badge>
  ) : (
    <WifiOff className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} text-red-600`} />
  );
}
